import { render, staticRenderFns } from "./UiFormLabel.vue?vue&type=template&id=345b6eac&"
import script from "./UiFormLabel.vue?vue&type=script&lang=ts&"
export * from "./UiFormLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports